import { nsTerminal } from '@/app/i18n/namespaces';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import PAYLUDD_PERSONALIZATION_INITIALIZATION_STATUS from '../../subscriptions/enums/PayluddPackageStatus';
import RenderPayluddMpfMode from '../components/renders/RenderPayluddMpfMode';

export default {
    PAYLUDD: {
        key: 'payludd',
        APPLICATION_VERSION: {
            parentKeys: ['payludd', 'version'],
            key: 'application',
            entity: 'payludd.state.application_version',
            namespace: nsTerminal
        },
        PAYLUDD_VERSION: {
            parentKeys: ['payludd', 'version'],
            key: 'payludd',
            entity: 'payludd.state.payludd_version',
            namespace: nsTerminal
        },
        ANDROID_VERSION: {
            parentKeys: ['payludd', 'version'],
            key: 'android',
            entity: 'payludd.state.android_version',
            namespace: nsTerminal
        },
        FIRMWARE: {
            parentKeys: ['payludd'],
            key: 'firmware',
            entity: 'payludd.state.firmware',
            namespace: nsTerminal
        },
        INITIALIZATION_STATUS: {
            parentKeys: ['payludd'],
            key: 'initializationStatus',
            type: FIELD_TYPES.BADGE,
            enum: PAYLUDD_PERSONALIZATION_INITIALIZATION_STATUS,
            entity: 'payludd.state.initialization_status',
            namespace: nsTerminal
        },
        PACKAGE_CODE: {
            parentKeys: ['payludd'],
            key: 'packageCode',
            entity: 'payludd.state.package_code',
            namespace: nsTerminal
        },
        PACKAGE_LABEL: {
            parentKeys: ['payludd'],
            key: 'packageLabel',
            entity: 'payludd.state.package_label',
            namespace: nsTerminal
        },
        COLOR: {
            parentKeys: ['payludd'],
            key: 'color',
            type: FIELD_TYPES.COLOR,
            entity: 'payludd.state.color',
            namespace: nsTerminal
        },
        LOGO: {
            parentKeys: ['payludd'],
            key: 'logo',
            type: FIELD_TYPES.IMAGE,
            entity: 'payludd.state.logo',
            namespace: nsTerminal
        },
        INITIALIZATION_DATE: {
            parentKeys: ['payludd'],
            key: 'initializationDate',
            type: FIELD_TYPES.DATE,
            entity: 'payludd.state.initialization_date',
            namespace: nsTerminal
        },
        POS_TERMINAL_STATE_DATE: {
            parentKeys: ['payludd'],
            key: 'posTerminalStateDate',
            type: FIELD_TYPES.DATE,
            entity: 'payludd.state.last_update',
            namespace: nsTerminal
        }
    },
    PAYLUDD_MPF_DISPLAY: {
        MODE: {
            key: 'payluddMpfMode',
            entity: 'payludd.state.mode',
            namespace: nsTerminal,
            type: FIELD_TYPES.COMPONENT,
            component: RenderPayluddMpfMode
        },
        PAYMENT_TICKETS: {
            key: 'payluddMpfPaymentReceiptKeys',
            entity: 'payludd.state.payment_tickets',
            namespace: nsTerminal,
            type: FIELD_TYPES.MULTI_ENTITY,
            entityPrefix: 'payludd.mpf.receipt.'
        },
        ADDITIONAL_SERVICES: {
            key: 'payluddMpfAdditionalServiceKeys',
            entity: 'payludd.state.additional_services',
            namespace: nsTerminal,
            type: FIELD_TYPES.MULTI_ENTITY,
            entityPrefix: 'payludd.mpf.service.'
        },
        BURGER_MENU_LOCK: {
            key: 'payluddMpfBurgerMenuLock',
            entity: 'payludd.state.burger_menu_lock',
            namespace: nsTerminal,
            type: FIELD_TYPES.BOOLEAN
        }
    }
};
